import React, { useContext } from 'react';
import { isRTL } from './utils';
import { useDefaultLocale } from './useDefaultLocale';
const I18nContext = /*#__PURE__*/ React.createContext(null);
/**
 * Provides the locale for the application to all child components.
 */ export function I18nProvider(props) {
    const { locale, children } = props;
    const defaultLocale = useDefaultLocale();
    const value = locale ? {
        locale,
        direction: isRTL(locale) ? 'rtl' : 'ltr'
    } : defaultLocale;
    return /*#__PURE__*/ React.createElement(I18nContext.Provider, {
        value: value
    }, children);
}
/**
 * Returns the current locale and layout direction.
 */ export function useLocale() {
    const defaultLocale = useDefaultLocale();
    const context = useContext(I18nContext);
    return context || defaultLocale;
}

//# sourceMappingURL=context.js.map